export default "<router-outlet></router-outlet>\n<!-- <ng-http-loader> </ng-http-loader> -->\n<div (window:beforeunload)=\"clearAllData()\"></div>";